import { LoadingLazyComponents } from 'ict24h-themes-react'
import { AppRouterItem } from 'ict24h-themes-react/lib/esm/modules/routers/AppRouters'
import { lazy } from 'react'
import {
  PHIEU_DAT_XE_APPROVED_PREFIX_URL,
  PHIEU_DAT_XE_CALENDAR_PREFIX_URL,
  PHIEU_DAT_XE_PREFIX_URL,
  PHIEU_DAT_XE_REPORT_PREFIX_URL,
  PHIEU_DAT_XE_WAITING_APPROVAL_PREFIX_URL,
} from './constants/config.phieu-dat-xe'

const ListPageAll = lazy(() => import('./pages/ListPage.All.PhieuDatXe'))
const ListPageWaitingApprove = lazy(
  () => import('./pages/ListPage.WaitingApprove.PhieuDatXe')
)
const ListPageApproved = lazy(
  () => import('./pages/ListPage.Approved.PhieuDatXe')
)

const DetailPage = lazy(() => import('./pages/DetailPage.PhieuDatXe'))

const ReportPageByResource = lazy(
  () => import('./pages/ReportPage.ByPhongHop.PhieuDatXe')
)
const ReportPageByPhongBan = lazy(
  () => import('./pages/ReportPage.ByPhongBan.PhieuDatXe')
)
const CalenDarPage = lazy(() => import('./pages/CalendarPage.PhieuDatXe'))

const listRouters: AppRouterItem[] = [
  {
    path: PHIEU_DAT_XE_PREFIX_URL,
    element: (
      <LoadingLazyComponents loadingType="skeleton">
        <ListPageAll />
      </LoadingLazyComponents>
    ),
  },
  {
    path: PHIEU_DAT_XE_WAITING_APPROVAL_PREFIX_URL,
    element: (
      <LoadingLazyComponents loadingType="skeleton">
        <ListPageWaitingApprove />
      </LoadingLazyComponents>
    ),
  },
  {
    path: PHIEU_DAT_XE_APPROVED_PREFIX_URL,
    element: (
      <LoadingLazyComponents loadingType="skeleton">
        <ListPageApproved />
      </LoadingLazyComponents>
    ),
  },
]

const detailRouters: AppRouterItem[] = listRouters.map(({ path }) => ({
  path: `${path}/:phieuDatXeId`,
  element: (
    <LoadingLazyComponents loadingType="skeleton">
      <DetailPage />
    </LoadingLazyComponents>
  ),
}))

const PhieuDatXeRouters: AppRouterItem[] = [
  ...listRouters,
  ...detailRouters,
  {
    path: `${PHIEU_DAT_XE_REPORT_PREFIX_URL}/by-xe`,
    element: (
      <LoadingLazyComponents loadingType="skeleton">
        <ReportPageByResource />
      </LoadingLazyComponents>
    ),
  },
  {
    path: `${PHIEU_DAT_XE_REPORT_PREFIX_URL}/by-phong-ban`,
    element: (
      <LoadingLazyComponents loadingType="skeleton">
        <ReportPageByPhongBan />
      </LoadingLazyComponents>
    ),
  },
  {
    path: PHIEU_DAT_XE_CALENDAR_PREFIX_URL,
    element: (
      <LoadingLazyComponents loadingType="skeleton">
        <CalenDarPage />
      </LoadingLazyComponents>
    ),
  },
]

export default PhieuDatXeRouters
